
import './App.css';
import { useState } from 'react';
import Calculator from './Calculator/Calculator';

function MyButton() {
  // const [name,setname]=useState("");
  const [car, setCar] = useState({
    brand: "Ford",
    model: "Mustang",
    year: "1964",
    color: "red"
  });
  //const todo=['todo1','todo2'];
  const updateColor = () => {
    setCar(previousState => {
      return { ...previousState, color: "blue" }
    });
  }

  return (
    <>
      <h1>My {car.brand}</h1>
      <p>
        It is a {car.color} {car.model} from {car.year}.
      </p>
      <button
        type="button"
        onClick={updateColor}
      >Blue</button>
    </>
  )
}

function App(props) {
  return (
    <>
      <h1>Hello {props.name},Welcome to my app?</h1>
      <MyButton></MyButton>
      <div className='App-header'>
        <Calculator></Calculator>
      </div>

    </>
  );
}

export default App;
